import { createIcon } from '@chakra-ui/icons';

export const Article = createIcon({
  displayName: 'Article',
  viewBox: '0 0 20 24',
  d: 'M0 0H20V16.6806L12.7222 24H0V0ZM17.7778 15.7639V2.22222H2.22222V21.7778H11.7917L17.7778 15.7639ZM9.33333 20V13.3333H16V15.5556H11.5556V20H9.33333ZM14.6667 4.88889V7.11111H5.33333V4.88889H14.6667ZM14.6667 8.88889V11.1111H5.33333V8.88889H14.6667Z',
});
